import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./../../assets/css/modal.css";

function CreateCompetitionModal({ onClose, onCreate }) {
  const [name, setName] = useState("");
  const [date, setDate] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const newCompetition = {
      name: name,
      date: date,
    };
    onCreate(newCompetition);
  };

  return ReactDOM.createPortal(
    <>
      <div className="modal-overlay" onClick={onClose} />
      <div className="modal-wrapper">
        <div className="modal">
          <h2>Create Competition</h2>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label htmlFor="name">Name:</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <label htmlFor="date">Date:</label>
              <input
                type="date"
                id="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
              />
            </div>
            <div className="button-group">
              <button type="submit">Create</button>
              <button type="button" onClick={onClose}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </>,
    document.body
  );
}

export default CreateCompetitionModal;
